// Giris formu gerekli mi? Dort bilesende kopyalanan hesap tek yerde.
export function computeLoginFormRequired(state) {
    // Tetikleyiciden baslandiysa, sayfa oturumu boyunca form atlanir.
    if (state.chat.skipLoginFormFromTrigger) return false;

    const loginFormRequired = state.setting.settings.loginFormRequired;
    const customLoginFormEnabled = state.setting.settings.customLoginFormEnabled;
    const customLoginFormIsValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;

    if (customLoginFormEnabled && !customLoginFormIsValid) return false;
    return loginFormRequired;
}



// WEBPACK FOOTER //
// ./src/utils/loginFormRequired.js